<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :modal="false"
        :title="WorkLineInfo.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="WorkLineInfo"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="产线名称">
          <el-input v-model="WorkLineInfo.cname" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="编号">
          <el-input v-model="WorkLineInfo.code" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="WorkLineInfo.remark" placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <div>
        <div slot="toolbar">
          <el-button type="primary" style="margin-bottom: 3%" @click="$refs.editWorkLineInfoCName.open(0)">新建</el-button>
        </div>
        <el-table
            :data="tableData"
            border
            style="width: 100%">
          <el-table-column prop="processName" align="center" label="工序名称"/>
          <el-table-column prop="code" align="center" label="工序编号"/>
          <el-table-column prop="showOrder" align="center" label="排序"/>
          <el-table-column prop="remark" align="center" label="备注"/>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="120px">
            <template slot-scope="scope">
              <el-button type="primary" @click.native.prevent="$refs.editWorkLineInfoCName.open(scope.row,scope.$index)">编辑</el-button>
              <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <work-line-info-c-name-edit ref="editWorkLineInfoCName" @save-success="getList"/>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constants from "../../../util/constants";
  import WorkLineInfoCNameEdit from "@/views/information/WorkLineInfo/WorkLineInfoCNameEdit";

  export default {
    name:"WorkLineInfoEdit",
    components: {WorkLineInfoCNameEdit},
    data() {
      return {
        constants,
        tableData: [],
        deleteIds: [],
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList:"",
        allDelete:false,
        WorkLineInfo: {
          cname: "",
          code: "",
          remark: "",
          pkid: "",
          addCompanyID: "",
          addDate: "",
          workLineDetails: [],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        this.WorkLineInfo.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `workLineInfoes/${this.WorkLineInfo.pkid}`)
          .then(resp => {
            this.WorkLineInfo = resp;
            this.tableData = this.WorkLineInfo.workLineDetails;
          });
      },
      getList(row,index) {
        if(index >= 0) {
          this.tableData[index].processName = row.processName;
          this.tableData[index].code = row.code;
          this.tableData[index].showOrder = row.showOrder;
          this.tableData[index].remark = row.remark;
        }else{
          this.tableData.push({processName: row.processName, code: row.code, showOrder: row.showOrder,remark: row.remark});
        }
      },
      //页面删除
      oneDelete(index,row) {
        this.tableData.splice(index,1);
        if(row.pkid) {
          this.deleteIds.push(row.pkid);
        }
      },
      //数据库真正删除
      delete() {
        this.$http
          .delete("basic","/workLineDetails/idList",this.deleteIds).then(() => {
            this.deleteIds = [];
          });
      },
      handleSubmit() {
        if(this.deleteIds.length) {
          this.delete();
        }
        console.log(this.tableData);
        if(this.WorkLineInfo.pkid>0) {
          for (let item of this.tableData) {
            if(item.pkid) {
              this.workDetailUpData(item);
            }else {
              item.mastPKID = this.WorkLineInfo.pkid;
              this.workDetailSave(item);
            }
          }
          this.handleSubmitUpData();
        }else {
          this.WorkLineInfo.workLineDetails = this.tableData;
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "workLineInfoes", this.WorkLineInfo)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      workDetailUpData(item) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "workLineDetails", item)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      workDetailSave(item) {
        console.log(item);
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "workLineDetails", item)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "workLineInfoes", this.WorkLineInfo)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
